import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { fetchEvent, editEvent, deleteEvent, returnFromEditCreateEvent, clearEditState } from '../../actions';
import EventForm from './EventForm';
import { CREATOR, GA_TRACKING_EDIT_PAGE } from '../helpers/AppConsts';
import { hasNoEditEvent } from '../helpers/EventUtils';
import ReactGA from 'react-ga';
import { Button, Icon } from 'semantic-ui-react';

const styles = {
  container: {
    minHeight: 'calc(100vh - 200px)',
    backgroundColor: '#f5f5f5',
    padding: '40px 20px',
  },
  content: {
    maxWidth: '800px',
    margin: '0 auto',
  },
  card: {
    backgroundColor: 'white',
    borderRadius: '12px',
    boxShadow: '0 2px 12px rgba(0,0,0,0.1)',
    padding: '30px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '25px',
    paddingBottom: '20px',
    borderBottom: '1px solid #eee',
  },
  headerIcon: {
    backgroundColor: '#569556',
    borderRadius: '10px',
    width: '45px',
    height: '45px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '15px',
  },
  title: {
    margin: 0,
    fontSize: '1.5rem',
    color: '#333',
  },
  subtitle: {
    margin: 0,
    color: '#666',
    fontSize: '0.9rem',
  },
  buttonGroup: {
    marginTop: '25px',
    paddingTop: '20px',
    borderTop: '1px solid #eee',
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '10px',
  },
  loadingWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '60px',
    color: '#666',
  },
};

const EventEdit = ({ edits, match, fetchEvent, editEvent, deleteEvent, returnFromEditCreateEvent, clearEditState }) => {
  useEffect(() => {
    ReactGA.ga('send', 'pageview', GA_TRACKING_EDIT_PAGE);
    fetchEvent(match.params.eventId, match.params.event_organizer);

    return () => {
      clearEditState();
    };
  }, [fetchEvent, clearEditState, match.params.eventId, match.params.event_organizer]);

  const onSubmit = (formValues) => {
    formValues.registered_players = ['placeholder'];
    formValues.event_id = edits.editEvent.event_id;
    formValues.event_organizer = edits.editEvent.event_organizer;
    formValues.event_img = edits.editEvent.event_img;
    formValues.event_results = edits.editEvent.event_results;
    formValues.event_date = edits.editEvent.event_date;
    editEvent(formValues);
  };

  const onDelete = () => {
    deleteEvent(edits.editEvent.event_id, edits.editEvent.event_date);
  };

  const onReturn = () => {
    returnFromEditCreateEvent();
  };

  if (hasNoEditEvent(edits)) {
    return (
      <div style={styles.container}>
        <div style={styles.content}>
          <div style={styles.card}>
            <div style={styles.loadingWrapper}>
              <Icon name="spinner" loading size="large" />
              <span style={{ marginLeft: '10px' }}>Loading event details...</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <div style={styles.card}>
          <div style={styles.header}>
            <div style={styles.headerIcon}>
              <Icon name="edit" size="large" style={{ color: 'white', margin: 0 }} />
            </div>
            <div>
              <h1 style={styles.title}>Edit Event</h1>
              <p style={styles.subtitle}>{edits.editEvent.event_name}</p>
            </div>
          </div>

          <EventForm
            onSubmit={onSubmit}
            isEditMode={true}
            reinitialize={true}
            initialValues={edits.editEvent}
          />

          <div style={styles.buttonGroup}>
            <Button basic onClick={onReturn}>
              <Icon name="arrow left" /> Back to Events
            </Button>
            <Button basic color="red" onClick={onDelete}>
              <Icon name="trash" /> Delete Event
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    edits: state.edits,
    currentUserEmail: CREATOR,
  };
};

export default connect(mapStateToProps, {
  fetchEvent,
  editEvent,
  deleteEvent,
  clearEditState,
  returnFromEditCreateEvent,
})(EventEdit);
